export enum PersonalityTestModalType {
    PERSONALITY_TEST = 'PERSONALITY_TEST',
    LEADERSHIP_PROFILE = 'LEADERSHIP_PROFILE'
}
